import { DownOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps, Space } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import React from "react";
import { appStore } from "src/appStore";

import * as styles from "./HeaderDropdown.module.less";

export const HeaderDropdown = observer(() => {
  const items: MenuProps["items"] = [
    {
      label: t("Logout"),
      key: "logout",
      onClick: () => appStore.logout(),
    },
  ];
  return (
    <Dropdown className={styles.box} menu={{ items }} trigger={["click"]}>
      <Space>
        {appStore.userInfo.email}
        <DownOutlined />
      </Space>
    </Dropdown>
  );
});
